// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__y2L3p","text":"SelectPayment_text__2zjrC","title":"SelectPayment_title__3zYIn","btn":"SelectPayment_btn__xijlg"};